import { render, staticRenderFns } from "./Checkbox.template.vue?vue&type=template&id=33b670cc&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b670cc",
  null
  
)

export default component.exports